module.exports = __webpack_public_path__ + "static/img/event_link_bg.49e92c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event_link_bg.png
// module id = GeLw
// module chunks = 1